import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { notificationTemplatesApi } from '../api/notificationTemplatesApi';
import type { TemplatePayload } from '../api/notificationTemplatesApi';

const QK = ['notification-templates'] as const;

export const useNotificationTemplates = (params?: { page?: number; page_size?: number; search?: string }) =>
  useQuery({
    queryKey: [...QK, params],
    queryFn: () => notificationTemplatesApi.list(params),
    staleTime: 2 * 60 * 1000,
  });

export const useCreateTemplate = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: TemplatePayload) => notificationTemplatesApi.create(payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
};

export const useUpdateTemplate = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...payload }: TemplatePayload & { id: string }) => notificationTemplatesApi.update(id, payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
};

export const useDeleteTemplate = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => notificationTemplatesApi.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
};
